import type { DeployTypeCode } from '../../core/types';
import type { ResourceConfigEntry } from '../pipeline-kernel/types';

const registry = new Map<DeployTypeCode, ResourceConfigEntry[]>();

/** 插件启动时注册该交付类型的资源监听条目 */
export function registerResourceConfigs(code: DeployTypeCode, configs: ResourceConfigEntry[]): void {
  registry.set(code, configs);
}

export function getResourceConfigsByDeployType(code: DeployTypeCode): ResourceConfigEntry[] {
  return registry.get(code) ?? [];
}
